module.exports = __webpack_public_path__ + "assets/img/79.9b007ceb.png";